module.exports = __webpack_public_path__ + "img/094.6edbd239.png";